import { useNavigate, useLocation } from "react-router-dom";
import {
  PAGE_KEYS,
  THEME_VARIANT,
  USER_CONFIG_STORAGE_KEY,
  TOKEN_STORAGE_KEY,
} from "shared/constants";
import { setPageConfig, setToken, decodeToken } from "utils";
import config from "config";

function getCookie(key) {
  var b = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
  return b ? b.pop() : '';
}

export default () => {
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const access_token = getCookie('access_token');
  const returnurl = params.get("returnurl");

  if (access_token && access_token.length > 0) {
    setToken(access_token);
    const decodedData = decodeToken(access_token);
    localStorage.setItem('rcAccountId', decodedData.rcuser_uid);
    setPageConfig(PAGE_KEYS.GLOBAL, { theme: 'light' });
    window.location.replace(returnurl);
  } else {
    navigate("/");
  }
  return null;
};

